import React, { useEffect, useState } from 'react'
import Table from '../shared/table/Table';
import { FiEdit3, } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom';
import { fetchData } from '../../utils/options';
import topTost from '../../utils/topTost';
import { MdThumbDown, MdThumbUp } from 'react-icons/md';



const CityTable = () => {
  const navigate = useNavigate();
  const [cityData, setCityData] = useState([]);

  const fetchCityData = async () => {
    const result = await fetchData('GetAllCity', {}, 'POST');
    if (result) {
      const city = result.city || [];
      setCityData(city);
    }
  };


  const toggleStatus = async (id) => {
    const result = await fetchData(`toggle-status-city/${id}`, {}, 'POST');

    if (result && result.code === 200) {
      fetchCityData();
      if (result?.status === 1) {
        topTost({
          title: 'Status updated successfully: Active',
          icon: 'success',
        });
      } else {
        topTost({
          title: 'Status updated successfully: Deactive',
          icon: 'success',
        });
      }
    } else {
      console.error('Failed to toggle state status:', result?.message);
    }
  };


  const columns = [

    {
      accessorKey: 'actions',
      header: () => "Actions",
      cell: ({ row }) => {
        const id = row.original.city_id;
        const is_active = row.original.city_status;

        return (
          <div className="hstack gap-2 justify-content-end">
            <span
              className="cursor-pointer"
              onClick={() => navigate(`/master/edit-city/${id}`)}
            >
              <FiEdit3 size={16} />
            </span>
          
            {is_active === 1 ? (
              <MdThumbUp
                className="cursor-pointer text-success"
                onClick={() => toggleStatus(id)}
              />
            ) : (
              <MdThumbDown
                className="cursor-pointer text-secondary"
                onClick={() => toggleStatus(id)}
              />
            )}
          </div>
        );
      },
      meta: {
        headerClassName: 'width-30', exportable: false,
      },
    },
    {
      accessorKey: 'state_title',
      header: () => 'State',
      cell: (info) => info.getValue(),
        defaultIsVisible: true,
    },
    {
      accessorKey: 'district_title',
      header: () => 'District',
      cell: (info) => info.getValue(),
        defaultIsVisible: true,
    },
    {
      accessorKey: 'city_title',
      header: () => 'City',
      cell: (info) => info.getValue(),
        defaultIsVisible: true,
    },

  ]
  useEffect(() => {
    fetchCityData();
  }, [])

  return (
    <>
      <Table data={cityData} columns={columns} />
    </>
  )
}

export default CityTable